import React from 'react';
import { FaArrowRight} from 'react-icons/fa';

export default function AppDevelopmentProcess() {
  const stages = [
    {
      title: "Research",
      subtitle: "Desk & User Research",
      description:
        "Thorough analysis of ",
      highlighted: false,
    },
    {
      title: "Design",
      subtitle: "Sketch & Visual Design",
      description:
      "Wireframing, prototyping",
      highlighted: false,
    },
    {
      title: "Development",
      subtitle: "App Development",
      description:
        "iOS App Development",
      highlighted: false,
    },
    {
      title: "Deployment",
      subtitle: "Publishing",
      description: "App Store & Google Play Store",
      highlighted: true,
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(to bottom right, #f3e8ff, #e0e7ff, #e0e0ff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        maxWidth: "100%"
      }}

    >
     <div className="container text-center" style={{ maxWidth: "1400px" }}>
  {/* Process Flow (One Row of Circles) */}
  <div
    className="conatiner d-flex justify-content-between align-items-center"
    style={{ gap: "0.5rem", maxWidth: "100%" }}
  >
    {stages.map((stage, index) => (
      <React.Fragment key={index}>
        {/* Circle Card */}
        <div
          className="conatine d-flex flex-column align-items-center justify-content-center text-center"
          style={{
            flex: 1,
            aspectRatio: "1 / 1",
            minWidth: "280px",
            maxWidth: "450px",
            borderRadius: "50%",
            padding: "2.5rem",
            background: stage.highlighted
              ? "linear-gradient(135deg, #6366f1, #a78bfa)"
              : "#fff",
            color: stage.highlighted ? "#fff" : "#333",
            boxShadow: stage.highlighted
              ? "0 10px 25px rgba(99,102,241,0.4)"
              : "0 5px 15px rgba(0,0,0,0.1)",
            transition: "0.3s ease",
            border: stage.highlighted
              ? "2px solid #818cf8"
              : "2px solid #ddd",
          }}
        >
          <h2
            style={{
              fontWeight: "bold",
              fontSize: "1.8rem",
              marginBottom: "0.5rem",
            }}
          >
            {stage.title}
          </h2>
          <h4
            style={{
              fontSize: "1.3rem",
              marginBottom: "1rem",
              fontWeight: "600",
            }}
          >
            {stage.subtitle}
          </h4>
          <p style={{ fontSize: "1rem"}}>
            {stage.description}
          </p>
        </div>

        {/* Arrow */}
        {index < stages.length - 1 && (
          <FaArrowRight
            size={42}
            style={{
              color:
                index === stages.length - 2
                  ? "#6366f1"
                  : "rgba(107,114,128,0.6)",
              flexShrink: 0,
            }}
          />
        )}
      </React.Fragment>
    ))}
  </div>

  {/* Additional Info */}
  <div className="mt-5 text-center">
    <p className="text-secondary fs-5">
      Seamless app development from concept to launch
    </p>
  </div>
</div>

    </div>
  );
}